<template>
  <ul>
    <li class="x-w140 x-h40 x-lh-40 x-cur-poi x-p-l-20" v-for="(item, index) in xtdata" :key='index' @click="clickXZ(item.tai,item.id)">
      <div class="x-d-flex x-p-l-15 x-row-between" @mouseenter="Yiru(item.id)" @mouseleave="YiChu(item.id)" :class="item.tai == true ?'c-ff0000 fen':'c-0'">
        <div class="x-d-flex" style="overflow: hidden;">
          <div class="wen" :title="item.name">{{item.name}}</div>
          <div class="wen" :title="'(下级'+indexZHI[index].userNuber+'个)'" v-if="indexZHI[index].userNuber != 0">(下级{{indexZHI[index].userNuber}}个) </div>
        </div>
        <div v-if="isExitHover == true && isid == item.id && item.tai == true" class="x-p-r-5" @click="AddClick(item.id)">
          <span class="el-icon-edit-outline x-font-16"></span>
        </div>
      </div>
      <Tree v-if="item.children && item.children.length > 0 && item.tai == true" :class="item.children ?'rightF':''" @AddClickF="AddClick" :xtdata='item.children'></Tree>
    </li>
  </ul>
</template>

<script>
  export default {
    components: {
    },
    props:{
      xtdata:{
        type:[Object,Array],
        default:""
      }
    },
    data() {
      return {
        indexZHI:[],
        //  鼠标移入
        isid:"0",
        isExitHover:false,
      };
    },
    computed: {},
    watch: {},
    methods: {
      // 点击选择当前 【打开下一级】
      clickXZ(tai,id){
        this.xtdata.forEach((item)=>{
          if(item.id == id){
            item.tai = true;
          }else{
            item.tai = false;
          }
        })
      },
      // 下级多少
      async xiaji(){
        this.indexZHI = [];
        for(let i=0;this.xtdata.length>i;i++){
          if(this.xtdata[i].children && this.xtdata[i].children.length > 0){
            this.indexZHI.push({"userNuber":this.xtdata[i].children.length});
          }else{
            this.indexZHI.push({"userNuber":0});
          }
        }
        // console.log(this.indexZHI);
      },
      // 移入移除
      Yiru(id){
        this.isid = id;
        this.isExitHover = true;
      },
      YiChu(id){
        this.isid = id;
        this.isExitHover = false;
      },
      //  新增机构
      AddClick(id){
        this.$emit('AddClickF',id);
      },
    },
    beforeCreate() {},
    async created() {
      this.xiaji();
    },
    beforeMount() {},
    mounted() {
    }
  }
</script>
<style lang="less" scoped>
  .rightF{
    width: 140px;
    height: calc(100vh - 213px);
    position: relative;
    left: 140px;
    top: -40px;
  }
  .fen{
    background-color: #fbf0f0;
    border-radius: 5px;
  }
  li{
    position: relative;
  }
  li:before {
    border-left: none;
  }
  li:after {
    border-top: none;
  }
  li:before{
    content: "";
    left: 0px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }
  li:after {
    content: "";
    left: 0px;
    position: absolute;
    right: auto;
    border-width: 1px;
  }
  li:before {
    border-left: 1px solid #cbcdce;
    bottom: 0px;
    height: 50px;
    top: 20px;
    width: 1px;
  }
  li:last-child:before {
    border-left: 1px solid #ffffff;
    bottom: 0px;
    height: 40px;
    top: 20px;
    width: 1px;
  }

  li:after {
    border-top: 1px solid #cbcdce;
    height: 20px;
    top: 20px;
    width: 20px;
  }
  // 文本省略号
  .wen{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
</style>



// WEBPACK FOOTER //
// src/components/Tree.vue